import type { ModelResults } from 'api';
import { PhotoEvidenceItemVariant } from 'ui';

export const getPhotoVariant = (modelResults?: ModelResults): PhotoEvidenceItemVariant => {
  if (!modelResults) return undefined;

  if (modelResults.outputs?.[0]?.image_rejected) {
    return 'warning';
  }

  if (modelResults.outputs?.[0]?.highest_grade_name === 'Reject') {
    return 'warning';
  }

  return 'success';
};
